import { KeyboardKeys } from '@/utils/Keyboard';
import { PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { Control, useController } from 'react-hook-form';
import IconButton from '@/components/ui/custom/buttons/IconButton';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import SpanInput from '@/components/ui/custom/dataInput/SpanInput';
import { CombinedFormFields } from './ChapterForm';

type SubchapterFormTitleProps = {
  control: Control<CombinedFormFields>;
};
export default function SubchapterFormTitle({
  control,
}: SubchapterFormTitleProps) {
  const [editingTitle, setEditingTitle] = useState(false);
  const {
    field: titleField,
    fieldState: { error },
  } = useController({
    control,
    name: 'title',
    rules: {
      required: 'O titulo é obrigatório',
    },
  });

  return (
    <div className="flex items-center gap-2.5 justify-center grow max-w-full">
      <SpanInput
        isEditing={editingTitle}
        {...titleField}
        errorLabelText={error?.message}
        errorLabelPosition="bottom"
        onKeyDown={event => {
          if (error?.message) return;
          if (event.key === KeyboardKeys.Enter) {
            setEditingTitle(false);
          }
        }}
      >
        {value => (
          <Text
            text={value}
            className="!font-poppins !text-24 text-base-content !font-700 underline decoration-secondary/50 decoration-2 underline-offset-4 !text-center text-wrap truncate"
          />
        )}
      </SpanInput>

      <ConditionalRenderer condition={!editingTitle}>
        <IconButton
          type="button"
          testId="editSubchapterTitle"
          icon={<PencilIcon className="text-accent w-4 h-4" />}
          onClick={() => setEditingTitle(true)}
        />
      </ConditionalRenderer>
      <ConditionalRenderer condition={editingTitle}>
        <IconButton
          type="button"
          testId="editSubchapterTitle"
          disabled={!!error?.message}
          icon={<XMarkIcon className="text-error w-4 h-4" />}
          onClick={() => setEditingTitle(false)}
        />
      </ConditionalRenderer>
    </div>
  );
}
